import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Bubble } from 'tea-component';
import GameImage from '@home/components/GameImage';
import { addImageMogr2Url, isObject } from '@intelligence/utils/commonUtils';

import './index.scss';

import ICON_LOADING from '@intelligence/assets/svg/loading.svg';

const CssImageTypeList = ['pc', 'console'];

export interface IImageData {
  name?: string;
  content?: string;
  img?: string;
  cover?: string;
  icon?: string;
  imgSrc?: string;
}

interface IImageRenderProps {
  loading?: boolean;
  entityType: IEntityType;
  searchValue?: string;
  item?: IImageData;
  getClick?: (item?: IImageData) => void;
}

const ImageRender: React.FC<IImageRenderProps> = (props) => {
  const { loading: loadingProps = false, entityType, searchValue, item, getClick } = props;

  const isMobile = entityType === 'mobile';
  const isPC = entityType === 'pc';
  const isConsole = entityType === 'console';
  const contentStr = item?.content || item?.name || '';

  const [loading, setLoading] = useState(true);

  const showLoading = loadingProps || loading;

  const hideLoading = () => {
    setTimeout(() => {
      setLoading(false);
    }, 300);
  };

  useEffect(() => {
    setLoading(true);
  }, [item?.imgSrc]);

  return (
    <Bubble dark content={contentStr}>
      <div
        className={classnames('dbi-table-img', {
          'dbi-table-img--loading': showLoading,
          'dbi-table-img--pc': isPC,
          'dbi-table-img--console': isConsole,
        })}
      >
        {showLoading && (
          <div
            className={classnames('dbi-table-img__loading-wrapper', {
              'dbi-img-loading-container': !isPC,
              'dbi-img-loading-container-pc': isPC,
            })}
          >
            <img className="dbi-table-img__loading-icon img-loading" src={ICON_LOADING} alt="" />
          </div>
        )}
        <GameImage
          className={classnames(
            'dbi-table-img__img',
            `dbi-cycle-${CssImageTypeList.includes(entityType) ? entityType : 'img'}`,
            {
              'img-loading': loading,
              // img-action 当只有搜索图片项与当前吻合时。才会出现高亮，不在遍历一遍数据增加actions
              'img-action': searchValue && [item?.imgSrc].includes(searchValue),
              'dbi-cycle-img': !isPC && !isConsole,
              'dbi-cycle-mobile': isMobile,
              'dbi-cycle-pc': isPC,
              'dbi-cycle-console': isConsole,
            },
          )}
          alt=""
          src={item?.imgSrc}
          entityType={entityType}
          bubbleContent={contentStr}
          onLoad={() => {
            hideLoading();
          }}
          onAbort={() => {
            hideLoading();
          }}
          onError={() => {
            hideLoading();
          }}
          onClick={() => {
            getClick?.(item);
          }}
        />
      </div>
    </Bubble>
  );
};

interface ITableImgProps {
  loading?: boolean;
  isNeedMogr?: boolean;
  entityType: IEntityType;
  searchValue?: string;
  cvm?: IImageData[];
  getClick?: (item?: IImageData) => void;
}

const TableImg: React.FC<ITableImgProps> = (props) => {
  const { loading, isNeedMogr = false, entityType, searchValue, cvm: list, getClick } = props;

  const showImgs = Array.isArray(list) && list.length > 0;

  // 压缩图片
  const getMogrImgObj = (item: IRecord) => {
    if (!isObject(item)) {
      return item;
    }

    const imgSrcTemp = item?.img || item?.cover || item?.icon || '';
    return {
      ...item,
      imgSrc: !isNeedMogr ? imgSrcTemp : addImageMogr2Url(imgSrcTemp, 96, 96),
    };
  };

  return (
    <div className="dbi-cycle-img-flex">
      {!showImgs && <div style={{ color: '#838697' }}>-</div>}
      {showImgs &&
        list.map((item: IRecord, i: any) => (
          <ImageRender
            key={i}
            loading={loading}
            entityType={entityType}
            searchValue={searchValue}
            item={getMogrImgObj(item)}
            getClick={getClick}
          />
        ))}
    </div>
  );
};

export default TableImg;
